const Resources = {

    table_headers: [
        {
            text:   'S. Scenario',
            align:  'start',
            value:  'staffing_scenario'
        },
        { 
            text:   'Name',
            value:  'name'
        },
        {
            text:   'Order',
            value:  'order'
        },
        {
            text:   'Daily Minutes',
            value:  'minutes'
        },
        {
            text:   'Days per week',
            value:  'days'
        }
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Budgeting',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Scenarios',
            href:   '/budgeting-staffing-scenario',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

}

export default Resources;